import { EnumCadastroTipo } from "model";

export class PerfilCadastroFormModel { 
    constructor(
        public tpCadastro?: EnumCadastroTipo,
        public nome: string = '',
        public descricao: string = ''
    ) { }
}